import errorHandler from "services/schoolService/errorHandler";

import {
  fetchSchoolInfoActionFactory,
  receiveSchoolInfo,
  updateSchoolInfoActionFactory
} from "../../state";
import {
  fetchMySchoolInfo as fetchMySchoolInfoClient,
  putMySchoolInfo
} from "../client";

export const fetchMySchoolInfo = fetchSchoolInfoActionFactory({
  requestFunction: fetchMySchoolInfoClient,
  storeAction: receiveSchoolInfo,
  errorHandler
});

export const updateMySchoolInfo = updateSchoolInfoActionFactory({
  requestFunction: putMySchoolInfo,
  storeAction: receiveSchoolInfo,
  errorHandler
});
